import { Box, Center, Stack, Text } from '@chakra-ui/react'
import type { IconDefinition } from '@fortawesome/pro-solid-svg-icons'

import Icon, { type IconProps } from './Icon/Icon'

export type IconBulletItem = {
  key: string
  icon: IconDefinition
  body: JSX.Element | string
}

export default function IconBullets({
  bullets,
  iconProps,
  iconAlignment = 'top',
}: {
  bullets: IconBulletItem[]
  iconProps: Pick<IconProps, 'backgroundColor' | 'color' | 'size'>
  iconAlignment?: 'top' | 'center'
}): JSX.Element {
  return (
    <Stack direction="column" spacing="12px">
      {bullets.map(({ key, icon, body }) => (
        <Box key={key}>
          <Stack direction="row" spacing="12px" align={iconAlignment}>
            <Center
              minWidth="24px"
              height="24px"
              bgColor={iconProps.backgroundColor}
              borderRadius="8px"
            >
              <Icon size={iconProps.size ?? 'lg'} faIcon={icon} color={iconProps.color} />
            </Center>
            <Box>{typeof body === 'string' ? <Text>{body}</Text> : body}</Box>
          </Stack>
        </Box>
      ))}
    </Stack>
  )
}
